import { ApiRequestInterceptor } from "./apiRequest";
import { PROMOCIONES } from "../constants/endpoints/endpoints";

export const fetchPromociones = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(PROMOCIONES.promociones, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de promociones");
    }
};
